import { AbstractControl, ValidatorFn } from '@angular/forms';

export function onlyNumbers(): ValidatorFn {
    const nameRe: RegExp = new RegExp(/[^0-9.,]+/g);

    return (control: AbstractControl): { [key: string]: any } | null =>
        (control.value && nameRe.test(control.value) && { onlyNumbers: true }) || null;
}
